import { apiInstance } from "../config/apiInstance";
import { AUDITOR_SIGNATURE } from "../index";
import { AuditorSignatureResponse } from "shared/models";
import Swal from "sweetalert2";

export const postAuditorSignature = async (
  file: File,
  acceptedTerms: boolean
): Promise<AuditorSignatureResponse | null> => {
  // Validate file type
  if (file.type !== "image/png") {
    Swal.fire({
      title: "Archivo inválido",
      text: "El archivo debe estar en formato PNG",
      icon: "error",
      timer: 4000,
    });
    return null;
  }

  const formData = new FormData();
  formData.append("file", file, file.name);
  formData.append("acceptedTerms", acceptedTerms.toString());

  try {
    const response = await apiInstance.post<AuditorSignatureResponse>(
      AUDITOR_SIGNATURE,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    Swal.fire({
      title: "Firma cargada exitosamente",
      text: "Su firma digital ha sido cargada correctamente",
      icon: "success",
      timer: 4000,
    });
    
    return response.data;
  } catch (e: any) {
    Swal.fire({
      title: "Error al cargar firma",
      text: e?.response?.data?.message || e.message || "No se pudo cargar la firma digital",
      icon: "error",
      timer: 5500,
    });
    return null;
  }
};
